import type { ReactNode } from 'react';
import classes from './TermList.module.css';

/** Строка условий: подпись и значение. */
export interface TermItem {
  readonly key: string;
  readonly label: string;
  readonly value: ReactNode;
}

// Условия «Бюллетеня»: строки «подпись — значение» на линиях, без рамки и значков; на телефоне подпись над значением.
// Пустые строки вызывающий не передаёт.
export default function TermList({ items }: { readonly items: readonly TermItem[] }) {
  return (
    <dl className={classes.list}>
      {items.map((item) => (
        <div key={item.key} className={classes.row}>
          <dt>{item.label}</dt>
          <dd>{item.value}</dd>
        </div>
      ))}
    </dl>
  );
}
